/* BarklyPaw AU offer page · GLOBAL store (trybarklypaw.com /en-au, AUD, pixel 1739708223850468). Vanilla JS; every feature checks its elements exist. */
(function () {
  'use strict';
  var w = window, d = document;
  function $(s, r) { return (r || d).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  var reduce = !!(w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var hasIO = 'IntersectionObserver' in w;

  /* 1. Timer */
  (function () {
    var KEY = 'bp_au_flash_deadline', OLD = 'bp_au_bogo_deadline', MIN_S = 13080, MAX_S = 15720, SLACK = 5000;
    var mem = null, deadline = 0, els = null, last = '';
    try { if (w.__bpT && isFinite(w.__bpT.d)) mem = w.__bpT.d; } catch (e) {}
    try { w.localStorage.removeItem(OLD); } catch (e) {}
    try { w.sessionStorage.removeItem(OLD); } catch (e) {}
    try { if (d.cookie.indexOf(OLD + '=') > -1) d.cookie = OLD + '=; max-age=0; path=/'; } catch (e) {}
    var readers = [
      function () { return w.localStorage.getItem(KEY); },
      function () { var m = d.cookie.match(/(?:^|;\s*)bp_au_flash_deadline=([^;]*)/); return m ? m[1] : null; },
      function () { return w.sessionStorage.getItem(KEY); },
      function () { return mem; }
    ];
    function duration() { return (MIN_S + Math.floor(Math.random() * (MAX_S - MIN_S + 1))) * 1000; }
    function valid(v, now) { return isFinite(v) && v > now && v <= now + MAX_S * 1000 + SLACK; }
    function read() {
      var now = Date.now(), v, i;
      for (i = 0; i < readers.length; i++) {
        try { v = parseInt(readers[i](), 10); } catch (e) { v = NaN; }
        if (valid(v, now)) return v;
      }
      return null;
    }
    function write(v) {
      mem = v;
      try { w.localStorage.setItem(KEY, String(v)); } catch (e) {}
      try { d.cookie = KEY + '=' + v + '; max-age=604800; path=/; SameSite=Lax'; } catch (e) {}
      try { w.sessionStorage.setItem(KEY, String(v)); } catch (e) {}
    }
    function resolve() { var v = read(); if (v === null) v = Date.now() + duration(); write(v); deadline = v; }
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function paint(list, txt) { for (var i = 0; i < list.length; i++) if (list[i].textContent !== txt) list[i].textContent = txt; }
    function render(rem) {
      var h = Math.floor(rem / 3600000), m = Math.floor((rem % 3600000) / 60000), s = Math.floor((rem % 60000) / 1000);
      var hh = String(h), mm = pad(m), ss = pad(s), key = hh + mm + ss;
      if (key === last) return;
      last = key;
      if (!els) els = { h: $$('[data-t-hrs]'), m: $$('[data-t-min]'), s: $$('[data-t-sec]'), hms: $$('[data-t-hms]') };
      paint(els.h, hh); paint(els.m, mm); paint(els.s, ss); paint(els.hms, hh + ':' + mm + ':' + ss);
    }
    function tick() {
      var rem = deadline - Date.now();
      if (!(rem > 0)) { deadline = Date.now() + duration(); write(deadline); rem = deadline - Date.now(); }
      render(rem);
    }
    function sync() { resolve(); tick(); }
    resolve(); tick();
    setInterval(tick, 250);
    w.addEventListener('storage', function (e) { if (e.key === KEY || e.key === null) sync(); });
    d.addEventListener('visibilitychange', function () { if (!d.hidden) sync(); });
    w.addEventListener('pageshow', sync);
    w.BP_TIMER = {
      getDeadline: function () { return deadline; },
      reset: function (at) { deadline = (typeof at === 'number' && isFinite(at)) ? at : Date.now() + duration(); write(deadline); tick(); return deadline; }
    };
  })();

  function track(ev, params) { try { if (typeof w.fbq === 'function') w.fbq('track', ev, params); } catch (e) {} }

  /* 2. #offer */
  var offer = $('#offer'), offerTitle = $('#offer-title');
  function goOffer(smooth) {
    if (!offer) return;
    offer.scrollIntoView({ behavior: smooth && !reduce ? 'smooth' : 'auto', block: 'start' });
    if (offerTitle) { try { offerTitle.focus({ preventScroll: true }); } catch (e) {} }
  }
  if (offer) {
    d.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a[href="#offer"]') : null;
      if (!a) return;
      e.preventDefault();
      try { history.replaceState(history.state, '', '#offer'); } catch (err) {}
      goOffer(true);
    });
    var touched = false, nav = null;
    ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach(function (t) { w.addEventListener(t, function () { touched = true; }, { passive: true, once: true }); });
    try { nav = performance.getEntriesByType('navigation')[0]; } catch (e) {}
    var realign = function () { if (!touched && location.hash === '#offer') offer.scrollIntoView({ block: 'start' }); };
    if (location.hash === '#offer' && !(nav && nav.type === 'reload')) {
      realign();
      w.addEventListener('load', realign);
      if (d.fonts && d.fonts.ready) d.fonts.ready.then(realign);
    }
  }

  /* 3. Sticky bar */
  var sticky = $('[data-sticky]'), heroCta = $('.hero__grid');
  if (sticky) {
    if (hasIO && offer && heroCta) {
      var vis = { h: false, o: false };
      var sio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { vis[en.target === offer ? 'o' : 'h'] = en.isIntersecting; });
        sticky.classList.toggle('is-on', !vis.h && !vis.o);
      });
      sio.observe(heroCta); sio.observe(offer);
    } else sticky.classList.add('is-on');
  }

  /* 4. Videos */
  var vids = $$('video[data-src]');
  function setPoster(v) { var ps = v.getAttribute('data-poster'); if (ps && !v.getAttribute('poster')) v.poster = ps; }
  function loadVid(v) { setPoster(v); if (!v.getAttribute('src')) v.src = v.getAttribute('data-src'); }
  function playVid(v) { if (reduce) return; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  vids.forEach(function (v) { if (reduce) v.controls = true; });
  if (hasIO) {
    var pio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { setPoster(en.target); pio.unobserve(en.target); } });
    }, { rootMargin: '150% 0px' });
    var vio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) { loadVid(v); playVid(v); } else if (!v.paused) v.pause();
      });
    }, { rootMargin: '40% 0px' });
    vids.forEach(function (v) { pio.observe(v); vio.observe(v); });
  } else vids.forEach(function (v) { loadVid(v); playVid(v); });

  /* 5. Carousels */
  function carousel(track, slides, prev, next, onIndex) {
    function step() { return slides.length > 1 ? (slides[1].offsetLeft - slides[0].offsetLeft) : (track.clientWidth || 1); }
    function index() { return Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / step()))); }
    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
      if (onIndex) onIndex(index(), Math.max(1, Math.round((track.clientWidth + 14) / step())));
    }
    var raf = 0;
    track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); }, { passive: true });
    if (prev) prev.addEventListener('click', function () { go(index() - 1); });
    if (next) next.addEventListener('click', function () { go(index() + 1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(index() + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(index() - 1); }
    });
    w.addEventListener('resize', update);
    update();
    return { go: go, update: update };
  }
  $$('[data-carousel]').forEach(function (c) {
    var track = $('.carousel__track', c), slides = $$('.carousel__slide', c), box = $('[data-dots]', c), dots = [];
    if (!track || !slides.length) return;
    var api;
    slides.forEach(function (s, i) {
      s.setAttribute('role', 'group');
      s.setAttribute('aria-roledescription', 'slide');
      s.setAttribute('aria-label', (i + 1) + ' of ' + slides.length);
      if (box) {
        var b = d.createElement('button');
        b.type = 'button'; b.className = 'dot';
        b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        b.addEventListener('click', function () { api.go(i); });
        box.appendChild(b); dots.push(b);
      }
    });
    api = carousel(track, slides, $('[data-prev]', c), $('[data-next]', c), function (i, visible) {
      var pages = slides.length - visible + 1, cur = Math.min(i, pages - 1);
      dots.forEach(function (b, j) { b.hidden = j >= pages; b.setAttribute('aria-current', j === cur ? 'true' : 'false'); });
    });
  });

  /* 6. Timeline reveal (once) */
  var tline = $('[data-timeline]');
  if (tline) {
    var tls = $$('.tl', tline);
    if (hasIO && !reduce) {
      tline.classList.add('tl-anim');
      var tio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); tio.unobserve(en.target); } });
      }, { rootMargin: '0px 0px -12% 0px' });
      tls.forEach(function (t) { tio.observe(t); });
    } else tls.forEach(function (t) { t.classList.add('is-in'); });
  }

  /* 7. Offer card */
  var form = $('[data-offer-form]');
  var PRODUCT_ID = '10438284247357', GIFT_ID = '52904279900477', GIFT_AUD = 28;
  var V = {
    XS: { LB: '52179766935869', LG: '52179767099709', PK: '52179767263549', CB: '52179767427389' },
    S:  { LB: '52179766968637', LG: '52179767132477', PK: '52179767296317', CB: '52179767460157' },
    M:  { LB: '52179767001405', LG: '52179767165245', PK: '52179767329085', CB: '52179767492925' },
    L:  { LB: '52179767034173', LG: '52179767198013', PK: '52179767361853', CB: '52179767525693' },
    XL: { LB: '52179767066941', LG: '52179767230781', PK: '52179767394621', CB: '52179767558461' }
  };
  var PRICE = { XS: 86, S: 100, M: 114, L: 143, XL: 215 }; /* AUD fallback, live store 2026-10-25 */
  var CMP = { XS: 122, S: 143, M: 164, L: 204, XL: 308 }; /* per-mat compare-at fallback */
  var LINE = { S: 'S · 60 × 50 cm · Pug, Dachshund, Cavalier', M: 'M · 70 × 55 cm · Frenchie, Beagle, Cocker', L: 'L · 100 × 70 cm · Lab, Golden, Staffy, Kelpie', XL: 'XL · 150 × 100 cm · Shepherd, Husky, or two dogs' };
  var AVAIL = {};
  var CNAME = { LB: 'Light Blue', LG: 'Light Grey', PK: 'Pink', CB: 'Coffee Brown', same: 'Same' };
  var CKEY = { 'Light Blue': 'LB', 'Light Gray': 'LG', 'Light Grey': 'LG', 'Pink': 'PK', 'Coffee Brown': 'CB' };
  var GSLIDE = { LB: 2, LG: 3 };
  var gallery = null;

  function money(n) { return '$' + (Math.abs(n - Math.round(n)) < 0.005 ? String(Math.round(n)) : n.toFixed(2)); }
  function field(name) { var f = form.elements.namedItem(name); return f ? f.value : ''; }
  function state() {
    var size = field('size'), color = field('color'), color2 = field('color2') || 'same';
    if (!V[size] || size === 'XS' || size === 'S') size = 'L'; /* XS + S stay in the map, not offered (Ram 10-26: M/L/XL) */
    if (!V[size][color] || !GSLIDE[color]) color = 'LB'; /* Light Blue + Light Grey only (Ram 10-26) */
    if (color2 !== 'same' && (!V[size][color2] || !GSLIDE[color2])) color2 = 'same';
    var two = form.elements.namedItem('sets2');
    return { size: size, color: color, color2: color2, sets: two && two.checked ? 2 : 1 };
  }
  function permalink(s) {
    var v1 = V[s.size][s.color], v2 = s.color2 === 'same' ? v1 : V[s.size][s.color2], q = s.sets;
    var items = v1 === v2 ? [v1 + ':' + (2 * q)] : [v1 + ':' + q, v2 + ':' + q];
    items.push(GIFT_ID + ':1');
    var qs = [];
    try {
      new URLSearchParams(location.search).forEach(function (val, key) {
        if (/^utm_/i.test(key) || key === 'fbclid') qs.push(encodeURIComponent(key) + '=' + encodeURIComponent(val));
      });
    } catch (e) {}
    qs.push('attributes[landing]=au-offer-v1');
    return 'https://trybarklypaw.com/en-au/cart/' + items.join(',') + '?' + qs.join('&');
  }
  function setText(sel, txt) { $$(sel, form).forEach(function (el) { el.textContent = txt; }); }
  var atc = form ? $('[data-atc]', form) : null, atcLabel = atc ? $('[data-atc-label]', atc) : null, atcTimer = 0;

  function render() {
    var s = state(), unit = PRICE[s.size], cmp = CMP[s.size], mats = 2 * s.sets, was = mats * unit, paid = unit * s.sets;
    var extra = s.sets === 2 ? Math.round(paid * 10) / 100 : 0, now = Math.round((paid - extra) * 100) / 100;
    /* price row = what you pay today: 1 set → unit price vs per-mat compare-at; 2 sets → total after the extra 10% vs 2 × compare-at */
    var shownNow = s.sets === 2 ? now : unit, shownWas = s.sets === 2 ? cmp * 2 : cmp;
    setText('[data-price-now]', money(shownNow) + ' AUD');
    var hasCmp = isFinite(cmp) && shownWas > shownNow;
    $$('[data-price-was],[data-price-off]', form).forEach(function (el) { el.hidden = !hasCmp; });
    if (hasCmp) { setText('[data-price-was]', money(shownWas)); setText('[data-price-off]', Math.round((1 - shownNow / shownWas) * 100) + '% OFF'); }
    $$('[data-price-sets]', form).forEach(function (el) { el.hidden = s.sets !== 2; });
    $$('.price-row', form).forEach(function (el) { el.classList.toggle('is-long', s.sets === 2); });
    setText('[data-size-line]', LINE[s.size] || '');
    setText('[data-mats-label]', mats + ' × BarklyPaw Cooling Mat, size ' + s.size);
    setText('[data-mats-was]', money(was));
    setText('[data-mats-now]', money(paid));
    $$('[data-extra]', form).forEach(function (el) { el.hidden = !extra; });
    setText('[data-extra-amt]', '−' + money(extra));
    setText('[data-total-was]', money(was));
    setText('[data-total-now]', money(now) + ' AUD');
    setText('[data-total-mats]', mats + ' mats');
    setText('[data-save]', 'You save ' + money(was - now) + ' on the mats plus the ' + money(GIFT_AUD) + ' gift');
    setText('[data-name="color"]', CNAME[s.color]);
    setText('[data-name="color2"]', CNAME[s.color2]);
    $$('[data-pet-price]').forEach(function (el) { el.textContent = money(PRICE.L) + ' AUD'; });
    $$('input[type="radio"]', form).forEach(function (inp) {
      var lab = inp.closest('label'); if (!lab) return;
      var off = (inp.name === 'color' || inp.name === 'color2') && inp.value !== 'same' && AVAIL[V[s.size][inp.value]] === false;
      inp.disabled = off;
      lab.classList.toggle('is-off', off);
      lab.classList.toggle('is-on', inp.checked);
    });
    $$('.twosets', form).forEach(function (el) { el.classList.toggle('is-on', s.sets === 2); });
    if (atc) atc.href = permalink(s);
  }

  var vcSent = false;
  function sendViewContent() {
    if (vcSent || !form) return; vcSent = true;
    track('ViewContent', { content_ids: [PRODUCT_ID], content_type: 'product_group', content_name: 'BarklyPaw Dog Cooling Mat', value: PRICE[state().size], currency: 'AUD' });
  }
  function applyProduct(p) {
    if (!p || String(p.id) !== PRODUCT_ID || !p.variants) return;
    var next = {}, nextCmp = {};
    p.variants.forEach(function (v) {
      var size = String(v.option2 || '').split(' ')[0], c = CKEY[v.option1];
      if (!V[size] || !c || V[size][c] !== String(v.id)) return;
      AVAIL[V[size][c]] = !!v.available;
      var price = Number(v.price) / 100, was = Number(v.compare_at_price) / 100;
      if (c === 'LB' && isFinite(price) && price > 0) { next[size] = price; nextCmp[size] = isFinite(was) && was > price ? was : NaN; }
    });
    Object.keys(next).forEach(function (k) { PRICE[k] = next[k]; CMP[k] = nextCmp[k]; });
    var s = state();
    ['color', 'color2'].forEach(function (name) {
      var cur = name === 'color' ? s.color : s.color2;
      if (cur === 'same' || AVAIL[V[s.size][cur]] !== false) return;
      var first = ['LB', 'LG', 'PK', 'CB'].filter(function (c) { return AVAIL[V[s.size][c]] !== false; })[0];
      var inp = first && $('input[name="' + name + '"][value="' + (name === 'color2' ? 'same' : first) + '"]', form);
      if (inp) inp.checked = true;
    });
  }
  function loadPrices() {
    var ctrl = w.AbortController ? new AbortController() : null;
    var to = setTimeout(function () { if (ctrl) ctrl.abort(); }, 4000);
    var done = function () { clearTimeout(to); render(); sendViewContent(); };
    if (!w.fetch) { done(); return; }
    fetch('https://trybarklypaw.com/en-au/products/barklypaw-cooling-mat-1plus1.js', { credentials: 'omit', signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
      .then(applyProduct)
      .catch(function () {})
      .then(done);
  }
  function preconnect() {
    if (preconnect.done) return; preconnect.done = true;
    ['https://trybarklypaw.com', 'https://shop.app'].forEach(function (h) {
      var l = d.createElement('link'); l.rel = 'preconnect'; l.href = h; d.head.appendChild(l);
    });
  }
  function restoreAtc() {
    clearTimeout(atcTimer);
    if (!atc) return;
    atc.classList.remove('is-loading'); atc.removeAttribute('aria-disabled');
    if (atcLabel) atcLabel.textContent = 'ADD TO CART';
  }
  if (form) {
    form.addEventListener('change', function (e) {
      render();
      var t = e.target;
      if (gallery && t && t.name === 'color' && GSLIDE[t.value] !== undefined) { var gi = GSLIDE[t.value]; if (gallery.load) gallery.load(gi); gallery.go(gi); }
    });
    var more = $('[data-more-colour]', form), row2 = $('#opt-color2');
    if (more && row2) more.addEventListener('click', function () {
      var open = row2.hidden;
      row2.hidden = !open; more.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (!open) { var same = $('input[name="color2"][value="same"]', form); if (same) same.checked = true; render(); }
      else { var first = $('input[name="color2"]:checked', row2); if (first) first.focus(); }
    });
    if (atc) {
      ['touchstart', 'mouseenter', 'focus'].forEach(function (t) { atc.addEventListener(t, preconnect, { passive: true }); });
      atc.addEventListener('click', function (e) {
        e.preventDefault();
        if (atc.classList.contains('is-loading')) return;
        var s = state(), url = permalink(s);
        track('AddToCart', { content_ids: [PRODUCT_ID], content_type: 'product_group', value: PRICE[s.size], currency: 'AUD', num_items: 2 * s.sets });
        atc.classList.add('is-loading'); atc.setAttribute('aria-disabled', 'true');
        if (atcLabel) atcLabel.textContent = 'Taking you to secure checkout…';
        atcTimer = setTimeout(restoreAtc, 8000);
        setTimeout(function () { w.location.assign(url); }, 150);
      });
      w.addEventListener('pageshow', function (e) { if (e.persisted) restoreAtc(); });
    }
    render();
    loadPrices();
  }

  /* 8. Gallery with thumbnail rail */
  var gal = $('[data-gallery]');
  if (gal) {
    var gTrack = $('[data-gallery-track]', gal), gSlides = $$('li', gTrack), rail = $('[data-thumbs]'), thumbs = [];
    thumbs = rail ? $$('.thumb', rail) : [];
    var cur = 0, booted = false;
    var loadSlide = function (i) {
      var im = gSlides[i] && $('img', gSlides[i]);
      if (!im || im.getAttribute('src') || !im.getAttribute('data-src')) return;
      if (im.getAttribute('data-srcset')) im.srcset = im.getAttribute('data-srcset');
      im.src = im.getAttribute('data-src');
    };
    var warm = function () {
      loadSlide(cur + 1);
      if (rail) $$('img[data-src]', rail).forEach(function (im) { im.src = im.getAttribute('data-src'); im.removeAttribute('data-src'); });
    };
    ['touchstart', 'pointerenter', 'focusin'].forEach(function (t) { gal.addEventListener(t, warm, { passive: true }); if (rail) rail.addEventListener(t, warm, { passive: true }); });
    w.addEventListener('load', function () { setTimeout(warm, 3000); });
    thumbs.forEach(function (b, i) { b.addEventListener('click', function () { loadSlide(i); gallery.go(i); }); });
    gallery = carousel(gTrack, gSlides, $('[data-prev]', gal), $('[data-next]', gal), function (i) {
      cur = i; loadSlide(i); if (booted) loadSlide(i + 1); booted = true;
      thumbs.forEach(function (t, j) { t.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      var t = thumbs[i];
      if (t && rail) {
        var l = t.offsetLeft - rail.offsetLeft, r = l + t.offsetWidth;
        if (l < rail.scrollLeft || r > rail.scrollLeft + rail.clientWidth) rail.scrollTo({ left: l, behavior: reduce ? 'auto' : 'smooth' });
      }
    });
    gallery.load = loadSlide;
  }

  /* 9. Size guide */
  var dlg = $('#sizeguide'), lastFocus = null;
  if (dlg) {
    var closeDlg = function () { if (dlg.close) dlg.close(); else { dlg.removeAttribute('open'); if (lastFocus) lastFocus.focus(); } };
    $$('[data-open-sizeguide]').forEach(function (b) {
      b.addEventListener('click', function () {
        lastFocus = b;
        if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
        d.body.style.overflow = 'hidden';
      });
    });
    dlg.addEventListener('click', function (e) { if (e.target === dlg || (e.target.closest && e.target.closest('[data-close]'))) closeDlg(); });
    dlg.addEventListener('close', function () { d.body.style.overflow = ''; if (lastFocus) lastFocus.focus(); });
  }

  /* 10. Reviews */
  var rvSec = $('#reviews'), rvList = $('[data-rv-list]'), rvStrip = $('[data-rv-strip]'), rvMore = $('[data-rv-more]'), rvStatus = $('[data-rv-status]');
  if (rvSec && rvList) {
    var REV = null, tag = 'All', shown = 8, PAGE = 8, started = false;
    var esc = function (t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return '&#' + c.charCodeAt(0) + ';'; }); };
    var starsHtml = function (n) { var h = '', i; for (i = 0; i < n; i++) h += '<svg><use href="#i-star"/></svg>'; return '<span class="stars stars--amber" role="img" aria-label="' + n + ' out of 5 stars">' + h + '</span>'; };
    var card = function (r) {
      var quote = !r.stars, badge = r.verified ? '<span class="rv__badge"><svg aria-hidden="true"><use href="#i-verified"/></svg>' + (quote ? 'Verified buyer' : 'Verified Buyer') + '</span>' : '';
      var city = r.city ? '🇦🇺 ' + esc(r.city) : '';
      var meta = [badge, city].filter(Boolean).join(' · ');
      var h = '<li class="rv' + (quote ? ' rv--quote' : '') + '"><div class="rv__top"><span class="rv__av" aria-hidden="true">' + esc(r.name.charAt(0)) + '</span>' +
        '<div class="rv__who"><p class="rv__name">' + esc(r.name) + '</p>' + (meta ? '<p class="rv__meta">' + meta + '</p>' : '') + '</div>' +
        (r.date ? '<span class="rv__date">' + esc(r.date) + '</span>' : '') + '</div>';
      if (quote) return h + '<p class="rv__text">&ldquo;' + esc(r.text) + '&rdquo;</p></li>';
      h += starsHtml(r.stars) + (r.title ? '<p class="rv__title">' + esc(r.title) + '</p>' : '') + '<p class="rv__text">' + esc(r.text) + '</p>';
      if (r.photo) h += '<img class="rv__photo" src="' + esc(r.photo) + '" width="96" height="96" loading="lazy" alt="Photo from ' + esc(r.name) + '&#39;s review" onerror="this.hidden=true">';
      return h + '</li>';
    };
    var renderList = function () {
      if (!REV) return;
      var list = REV.filter(function (r) { return tag === 'All' || (r.tags || []).indexOf(tag) >= 0; });
      rvList.innerHTML = list.slice(0, shown).map(card).join('');
      if (rvMore) rvMore.hidden = list.length <= shown;
      if (rvStatus) rvStatus.textContent = 'Showing ' + Math.min(shown, list.length) + ' of ' + list.length + ' reviews';
    };
    var renderStrip = function () {
      if (!rvStrip || !REV) return;
      var seen = {}, html = '';
      REV.forEach(function (r) {
        var base = r.photo ? String(r.photo).split('?')[0] : '';
        if (!base || seen[base]) return; seen[base] = 1;
        html += '<li><img src="' + esc(base) + '?width=240" width="84" height="84" loading="lazy" alt="Photo from ' + esc(r.name) + '&#39;s review" onerror="this.parentNode.hidden=true"></li>';
      });
      rvStrip.innerHTML = html;
    };
    var loadReviews = function () {
      if (started || !w.fetch) return; started = true;
      fetch(rvSec.getAttribute('data-reviews-src') || 'data/reviews.json').then(function (r) { if (!r.ok) throw new Error('http'); return r.json(); })
        .then(function (data) { REV = data; renderStrip(); renderList(); })
        .catch(function () { started = false; });
    };
    $$('[data-chips] button').forEach(function (b, i, all) {
      b.addEventListener('click', function () {
        all.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        tag = b.getAttribute('data-tag'); shown = PAGE; renderList();
      });
    });
    if (rvMore) rvMore.addEventListener('click', function () { shown += PAGE; renderList(); });
    if (rvStatus) rvStatus.className += ' sr';
    if (hasIO) {
      var rio = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { loadReviews(); rio.disconnect(); } }, { rootMargin: '1200px 0px' });
      rio.observe(rvSec);
    }
    w.addEventListener('load', function () { setTimeout(loadReviews, 2500); });
  }

  /* 11. Ship cutoff: 14:00 Australia/Sydney, every day */
  var sc = $('[data-shipcut]');
  if (sc && w.Intl) {
    var scDay = $('[data-shipcut-day]', sc), scLeft = $('[data-shipcut-left]', sc), F = null, FD = null;
    try {
      F = new Intl.DateTimeFormat('en-AU', { timeZone: 'Australia/Sydney', hourCycle: 'h23', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' });
      FD = new Intl.DateTimeFormat('en-AU', { timeZone: 'Australia/Sydney', weekday: 'long', day: 'numeric', month: 'long' });
    } catch (e) { F = null; }
    var parts = function (f, t) { var o = {}; f.formatToParts(t).forEach(function (x) { o[x.type] = x.value; }); return o; };
    var offset = function (t) { var x = parts(F, t); return Date.UTC(+x.year, x.month - 1, +x.day, +x.hour % 24, +x.minute, +x.second) - Math.floor(t / 1000) * 1000; };
    var shipTick = function () {
      var now = Date.now(), x = parts(F, now), secs = (+x.hour % 24) * 3600 + (+x.minute) * 60 + (+x.second), today = secs < 50400;
      var day = +x.day + (today ? 0 : 1), at = Date.UTC(+x.year, x.month - 1, day, 14, 0, 0), target = at - offset(now);
      target = at - offset(target);
      var left = Math.max(0, Math.floor((target - now) / 1000)), q = parts(FD, target);
      if (!q.weekday || !q.month || !isFinite(left)) return;
      var label = (today ? 'Ships today, ' : 'Ships tomorrow, ') + q.weekday + ' ' + q.day + ' ' + q.month;
      if (scDay.textContent !== label) scDay.textContent = label;
      scLeft.textContent = Math.floor(left / 3600) + 'hr ' + Math.floor(left % 3600 / 60) + 'mins ' + (left % 60) + 'sec';
      sc.hidden = false;
    };
    if (F && FD) { try { shipTick(); setInterval(shipTick, 1000); } catch (e) {} }
  }
})();
